import { render } from "./user-settings.vue?vue&type=template&id=7476a2b2"
import script from "./user-settings.vue?vue&type=script&lang=js"
export * from "./user-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__